import React from "react";
import { AppConfirmDialog } from "components/common/dialogs";

const DeleteConfirmDialog = ({ open, title, message, submitting, onClose, onConfirm }) => (
  <AppConfirmDialog open={open} title={title || "Xác nhận xóa"}
    message={message || "Bạn có chắc chắn muốn xóa dữ liệu này?"}
    type="delete" loading={submitting} onClose={onClose} onConfirm={onConfirm} />
);

export default DeleteConfirmDialog;
